const EVENT_ADD_TO_CART = 'event-add-to-cart';
const addToCartEventTrigger = () => {
	document.querySelectorAll('.js-add-to-cart-btn').forEach(btn => {
		btn.addEventListener('click',() => {
			const event = new CustomEvent(EVENT_ADD_TO_CART);
			document.dispatchEvent(event);
		});
	});
};

export {EVENT_ADD_TO_CART, addToCartEventTrigger};